import { Fetcher } from '@hugendubel/ws_client';
import { Globals } from './globals';
import { ProductFilter } from './ws/WS';

export const API_PREFIX = '/rest/v1/';

export const clientFetch = async (url: string, options?: RequestInit) => {
    const headers = await prepareHeaders();
    return await Globals.window().fetch(API_PREFIX + url, {
        headers,
        ...options,
    });
};

const prepareHeaders = async () => {
    const token = await Fetcher.getOrAcquireAccessToken(false);
    return headers({ auth: token });
};

export const headers = ({ auth, encoding }: { auth?: string; encoding?: boolean }): { [key: string]: string } => {
    const result = {} as { [key: string]: string };

    if (auth) result.Authorization = 'Bearer ' + auth;
    if (encoding) result['Content-type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
    else result['Content-type'] = 'application/json; charset=UTF-8';
    result['Accept'] = 'application/json';

    return result;
};

const bonusShopSearch = async (params: {
    maxPoints?: number;
    offset: number;
    maxResults: number;
    eanFilter?: string;
    sortField: string;
    ascending: boolean;
    productFilter?: ProductFilter;
}) => {
    const filteredParams = Object.entries(params)
        .filter(([_, value]) => value !== undefined && value !== null)
        .map(([key, value]) => [key.toString(), value?.toString()]);

    const queryString = new URLSearchParams(Object.fromEntries(filteredParams)).toString();

    return clientFetch('bonusshop/search?' + queryString, { method: 'POST' });
};

export const ClientFetch = { bonusShopSearch, clientFetch };
